var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "content-panel-login"
  }, [_c('header', {
    staticClass: "login-header"
  }, [_c('img', {
    staticClass: "logo-img",
    attrs: {
      "src": _vm.logo
    }
  })]), _c('div', {
    staticClass: "login-body"
  }, [_c('stroked-container', [_c('button', [_c('a', {
    directives: [{
      name: "link",
      rawName: "v-link",
      value: {
        path: '/login'
      },
      expression: "{ path: '/login' }"
    }],
    domProps: {
      "innerHTML": _vm._s(_vm.buttonClose)
    }
  })]), _c('div', {
    staticClass: "unsupported"
  }, [_c('h1', [_vm._v("Oops, outdated or unsupported browser detected.")]), _c('p', [_vm._v("\n          You are seeing this message because we detected an outdated or\n          unsupported browser being used. We recommend that you udpate to the\n          latest version of Chrome, Firefox, Internet Explorer, or Safari to\n          ensure you can access Keyboarding Without Tears.\n        ")]), _c('h2', {
    staticClass: "links"
  }, [_vm._v("\n          Use the links below to download the latest version of supported\n          browsers.\n        ")]), _c('ul', [_c('li', [_c('a', {
    staticClass: "icon chrome",
    attrs: {
      "href": "https://www.google.com/chrome/"
    }
  }, [_vm._v("\n              Chrome\n            ")])]), _c('li', [_c('a', {
    staticClass: "icon firefox",
    attrs: {
      "href": "https://www.firefox.com/"
    }
  }, [_vm._v("\n              Firefox\n            ")])]), !_vm.isMac ? _c('li', {
    staticClass: "icon edge"
  }, [_c('a', {
    attrs: {
      "href": "http://www.microsoft.com/en-us/windows/microsoft-edge/"
    }
  }, [_vm._v("\n              Edge\n            ")])]) : _vm._e(), _vm.isMac ? _c('li', [_c('a', {
    staticClass: "icon safari",
    attrs: {
      "href": "http://www.apple.com/safari/"
    }
  }, [_vm._v("\n              Safari\n            ")])]) : _vm._e()]), _c('p', [_vm._v("\n          Already upgraded but still having problems? Contact Customer Care at\n          888-983-8409 or\n          "), _c('a', {
    attrs: {
      "href": "mailto:technology@hwtears.com"
    }
  }, [_vm._v("Email Us")]), _vm._v(".\n        ")])])])], 1)]);
}
var staticRenderFns = []

export { render, staticRenderFns }